
import pages from './pages'

// Array of sections
export default [ ...pages]
